export default {
    hasError: state => key => {
        return state.validationErrors[key] !== undefined;
    },

    hasMultilingualError: (state, getters) => key => {
        return key ? getters.hasError(String(key).replace(/\[/g, '.').replace(/\]/g, '')) : false;
    }
};
